import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function RequirementLevelBadge({ attrib }) {
  const { t } = useTranslation("pim");
  let color = "gray";
  switch (attrib.requirementLevel) {
    case "REQUIRED":
      color = "red";
      break;
    case "OPTIONAL":
      color = "green";
      break;
    case "RECOMMENDED":
      color = "blue";
      break;
  }
  return (
    <Badge color={color} variant="outline">
      {t(`legacyProducts.requirementLevel.${attrib.requirementLevel}`, {
        defaultValue: attrib.requirementLevel,
      })}
    </Badge>
  );
}
